import {
  CLOSETGroupItem,
  GetCLOSETGroupsListResponse,
  GetCLOSETGroupsParams,
} from 'types/api/groups/closet';
import { getClosetGroups } from 'api/groups/closet';
import { useEffect, useState } from 'react';
import { CLOSETGroupsInitialSearchParams } from './useCLOSETGroupsInitialSearchParams';

interface Props {
  initialSearchParams: CLOSETGroupsInitialSearchParams;
}

export const useCLOSETGroupsQuery = ({ initialSearchParams }: Props) => {
  const [list, setList] = useState<CLOSETGroupItem[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [filterParams, setFilterParams] = useState<
    Omit<GetCLOSETGroupsParams, 'pageSize' | 'pageNo'>
  >({
    startDate: initialSearchParams.dateInterval[0],
    endDate: initialSearchParams.dateInterval[1],
    planTypes: initialSearchParams.planTypeValues,
    paymentMethods: initialSearchParams.paymentMethodValues,
    keyword: initialSearchParams.keyword,
    searchType: initialSearchParams.searchType,
    managerEmail: initialSearchParams.managerEmail || '',
  });
  const [pageInfo, setPageInfo] = useState<Omit<GetCLOSETGroupsListResponse, 'items'>>({
    pageSize: 0,
    currentPage: 0,
    totalItems: 0,
    totalPages: 0,
  });

  const handleGroupList = (
    params: Omit<GetCLOSETGroupsParams, 'pageSize' | 'pageNo'>,
    pageNo: number,
  ): Promise<void> => {
    const fetchGroupList = async (
      params: Omit<GetCLOSETGroupsParams, 'pageSize' | 'pageNo'>,
      pageNo: number,
    ) => {
      try {
        setIsLoading(true);
        const { items, ...rest } = await getClosetGroups({
          ...params,
          pageSize: 20,
          pageNo,
        });
        setList(items);
        setPageInfo(rest);
      } catch (error) {
        console.error('Error fetching group list:', error);
        setList([]);
      } finally {
        setIsLoading(false);
      }
    };

    setFilterParams(params);
    return fetchGroupList(params, pageNo);
  };

  useEffect(() => {
    void handleGroupList(filterParams, 1);
  }, []);

  return {
    isLoading,
    data: { list, pageInfo },
    params: filterParams,
    handleGroupList,
  };
};
